import { createContext } from 'react';

import { type ReactionsSummaryQueryResponse } from '../hydrators/types';

export type ConfluenceExperimentsContextType = {
	getPageRecommendationData: () => {
		pageRecommendationData: PageRecommendationData | undefined;
		recommendedPageQueryStatus: {
			loading: boolean;
			error: Error | undefined;
		};
		hoverPageCardQueryStatus: {
			loading: boolean;
			error: Error | undefined;
		};
	};
	useInlineReactionsData: (numberOfReactedUsers: number, skip: boolean) => InlineReactionsData;
	getPageDataFromUrl: (url: string) => PageData;
};

export type PageRecommendationData = {
	pageOwner: {
		name: string;
		avatarUrl: string;
	};
	page: {
		title: string;
		url: string;
	};
};

const defaultData = {
	loading: false,
	error: undefined,
};

export type InlineReactionsData = {
	data: {
		authorName: string | undefined;
		authorAvatar: string | undefined;
		reactionsCount: number | undefined;
		reactionsSummary: ReactionsSummaryQueryResponse | undefined;
		reactedUsers: string[] | undefined;
	};
	loading: boolean;
	error: Error | undefined;
};

export type PageData = {
	contentId: string | undefined;
	contentType: string | undefined;
	spaceKey: string | undefined;
};

export const ConfluenceExperimentsContext = createContext<ConfluenceExperimentsContextType>({
	getPageRecommendationData: () => ({
		pageRecommendationData: undefined,
		recommendedPageQueryStatus: defaultData,
		hoverPageCardQueryStatus: defaultData,
	}),
	useInlineReactionsData: (_numberOfReactedUsers: number, _skip: boolean) => ({
		data: {
			authorName: undefined,
			authorAvatar: undefined,
			reactionsCount: undefined,
			reactionsSummary: undefined,
			reactedUsers: undefined,
		},
		loading: false,
		error: undefined,
	}),
	getPageDataFromUrl: () => ({
		contentId: undefined,
		contentType: undefined,
		spaceKey: undefined,
	}),
});
